import React from 'react';

export default function PageHeader({ title, description, actions, className = '' }) {
  return (
    <header className={`shrink-0 mb-4 ${className}`}>
      <div className="flex items-center gap-3 min-h-8">
        <h1 className="text-title text-ink truncate">{title}</h1>
        {actions && <div className="ml-auto flex items-center gap-2">{actions}</div>}
      </div>
      {description && <p className="mt-1 max-w-[72ch] text-body text-graphite">{description}</p>}
    </header>
  );
}
